import { Dispatch, SetStateAction } from 'react'

interface InteractiveTextAreaProps {
  value: string
  setValue: Dispatch<SetStateAction<string>>
  multiline?: boolean
  placeholder: string
  rows?: number
}

export const InteractiveTextArea = ({
  value,
  setValue,
  placeholder,
  multiline = false,
  rows = 3,
}: InteractiveTextAreaProps) => {
  return (
    <textarea
      rows={multiline ? rows : 3}
      value={value}
      placeholder={placeholder}
      onChange={(e) => setValue(e.target.value)}
      className='w-full hover:ring-2 focus:ring-2 hover:ring-[#001A3D] focus:ring-[#001A3D] placeholder:text-[#405985] hover:placeholder:text-[#83A7D7] focus:placeholder:text-white border-none focus:border-none focus:outline-none caret-[#83A7D7] p-4 text-[#586885] rounded-[20px] transition-all duration-300 bg-white shadow-[0.2px_0.2px_30px_rgba(190,190,223,0.5)] resize-none'
    />
  )
}
